/** Format a public price without routing decimal strings through a float. */
export function formatConstructionMoney(
  value: unknown,
  currency = 'USD',
  missing = 'Not available',
): string {
  if (typeof value === 'number') {
    // Legacy numeric DTOs have already lost any precision beyond this bound.
    if (!Number.isFinite(value) || Math.abs(value) > Number.MAX_SAFE_INTEGER / 100) {
      return missing;
    }
    value = Math.abs(value) < 0.005 ? '0' : value.toString();
  }
  if (typeof value !== 'string') return missing;

  const match = /^([+-]?)(\d+)(?:\.(\d+))?$/.exec(value.trim());
  if (!match) return missing;

  const [, sign, whole, fraction = ''] = match;
  const oneHundred = BigInt(100);
  let cents = BigInt(whole) * oneHundred;
  cents += BigInt((fraction + '00').slice(0, 2));
  if ((fraction[2] || '0') >= '5') cents += BigInt(1);

  let currencySymbol: string;
  try {
    currencySymbol = new Intl.NumberFormat('en-US', {
      style: 'currency', currency,
    }).formatToParts(0).find((part) => part.type === 'currency')?.value || currency;
  } catch {
    return missing;
  }

  const dollars = (cents / oneHundred).toString();
  const grouped = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const centDigits = (cents % oneHundred).toString().padStart(2, '0');
  return `${sign === '-' && cents !== BigInt(0) ? '-' : ''}${currencySymbol}${grouped}.${centDigits}`;
}
